import createActionTypes from './createActionTypes'

export const namespace = 'UI'

export const types = createActionTypes(namespace, [
  'TOGGLE_DRAWER',
  'TOGGLE_MODAL',
  'TOGGLE_SNACKBAR',
  'TOGGLE_BANNER',
  'TOGGLE_FULLSCREEN_BUTTON',
  'SET_DEVICE_WIDTH',
  'SET_DEVICE_HEIGHT',
  'SET_DEVICE_SIZE',
  'SET_IS_MOBILE_MENU_OPEN',
  'SET_IS_VERTICAL_SCROLL_ENABLED',
])

export const toggleDrawer = active => ({
  type: types.TOGGLE_DRAWER,
  payload: {
    active,
  },
})

export const toggleModal = active => ({
  type: types.TOGGLE_MODAL,
  payload: {
    active,
  },
})

export const toggleSnackbar = (active, message = '', buttonText = '') => ({
  type: types.TOGGLE_SNACKBAR,
  payload: {
    active,
    message,
    buttonText,
  },
})

export const toggleBanner = (id, active) => ({
  type: types.TOGGLE_BANNER,
  payload: {
    id,
    active,
  },
})

export const toggleFullscreenButton = visible => ({
  type: types.TOGGLE_FULLSCREEN_BUTTON,
  payload: {
    visible,
  },
})

export const setDeviceWidth = deviceWidth => ({
  type: types.SET_DEVICE_WIDTH,
  payload: {
    deviceWidth,
  },
})

export const setDeviceHeight = deviceHeight => ({
  type: types.SET_DEVICE_HEIGHT,
  payload: {
    deviceHeight,
  },
})

export const setDeviceSize = deviceSize => ({
  type: types.SET_DEVICE_SIZE,
  payload: {
    deviceSize,
  },
})

export const setIsMobileMenuOpen = isMobileMenuOpen => ({
  type: types.SET_IS_MOBILE_MENU_OPEN,
  payload: {
    isMobileMenuOpen,
  },
})

export const setIsVerticalScrollEnabled = isVerticalScrollEnabled => ({
  type: types.SET_IS_VERTICAL_SCROLL_ENABLED,
  payload: {
    isVerticalScrollEnabled,
  },
})
